<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";

const props = defineProps({
  align: {
    type: String,
    default: "right",
  },
  width: {
    type: String,
    default: "48",
  },
  contentClasses: {
    type: Array,
    default: () => ["py-1", "bg-white"],
  },
});

let open = ref(false);

const closeOnEscape = (e) => {
  if (open.value && e.key === "Escape") {
    open.value = false;
  }
};

onMounted(() => document.addEventListener("keydown", closeOnEscape));
onUnmounted(() => document.removeEventListener("keydown", closeOnEscape));

const widthClass = computed(() => {
  return {
    48: "w-48",
  }[props.width.toString()];
});

const alignmentClasses = computed(() => {
  if (props.align === "left") {
    return "origin-top-left left-0";
  }

  if (props.align === "right") {
    return "origin-top-right right-0";
  }

  if (props.align === "bottom") {
    return "origin-bottom-right right-0";
  }

  return "origin-top";
});
</script>

<template>
  <div class="wrapper">
    <div @click="open = !open">
      <slot name="trigger" />
    </div>

    <!-- Full Screen Dropdown Overlay -->
    <div v-show="open" class="overlay" @click="open = false" />

    <Transition name="fade-grow">
      <div
        v-show="open"
        class="dropdown"
        :class="[widthClass, alignmentClasses]"
        style="display: none"
        @click="open = false"
      >
        <div :class="contentClasses">
          <slot name="content" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.dropdown {
  position: absolute;
  z-index: 50;
  bottom: 100%;
  margin-bottom: 0.5rem;
  width: max-content;

  @include rounded-borders-md;
  @include box-shadow-lg;

  & > div {
    @include rounded-borders-md;
    box-shadow: 0 0 0 0 1px var(--clr-border);
  }
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.wrapper {
  position: relative;
}

/* transform origin classes */
.origin-bottom-right {
  transform-origin: bottom right;

  top: 100%;
}

.origin-top-left {
  transform-origin: top left;
}

.origin-top-right {
  transform-origin: top right;
}

.origin-top {
  transform-origin: top;
}

.left-0 {
  left: 0;
}

.right-0 {
  right: 0;
}

.bg-white {
  background-color: var(--clr-bg-secondary);
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
</style>
